import React from "react";

const Introduction = () => (
  <div style={{ margin: 50 }} className="swagger-ui">
    <h2>Welcome to the YouNeed API</h2>
    <p className="mt-4">
      You can find here several API to access to some of your YouNeed data. To
      use these services you have to be a YouNeed customer.
    </p>
    <p>
      The YouNeed API is built on REST principles. Authenticated users can
      interact with any of our URIs by using the specified HTTP request method.
    </p>
    <p>
      To receive the credential to access, the administrator must send an email
      to api@ambrogio.com
    </p>
    <p>
      You can call at most 2000 APIs within a day (from 00:00 to 23:59). If you
      need more please send an email to api@ambrogio.com
    </p>
  </div>
);

export default Introduction;
